<template>
  <transition name="agreement-fade">
    <div v-if="visible" class="agreement-overlay" @click.self="close">
      <div class="agreement-dialog">
        <div class="agreement-header">
          <span class="agreement-title">AI功能使用规范</span>
          <i class="el-icon-close agreement-close" @click="close"></i>
        </div>
        <div class="agreement-body">
          <h3 style="text-align:center;margin-top:0;">AI创作平台使用规范</h3>

          <h4>一、使用说明</h4>
          <p>感谢您使用本AI创作平台，请您在开始使用本AI创作平台之前，认真阅读并充分理解本规范。我们深知个人信息对您的重要性，并将竭尽全力保护您的个人信息安全。我们将按国家法律法规要求，恪守权责一致、目的明确、选择同意、最少够用、公开透明、确保安全、主体参与的原则，保护您的个人信息。</p>
          <p>本AI创作平台的主要适用人群是成年人，如您未满18周岁，请在监护人陪同下仔细阅读并充分理解本规范，并在征得监护人的同意后使用本AI创作平台。</p>

          <h4>二、知识产权体系说明</h4>
          <p>在您使用本AI创作平台期间，您本AI创作平台提交文字、图片、音视频等内容（合称"输入内容"），本AI创作平台接收响应您的输入内容而生成图片、音视频、文字等内容（合称"生成内容"），具体的输入内容、生成内容类型以产品功能实际情况为准。您理解并承诺，输入内容以及您在使用本AI创作平台时发布的内容，包括但不限于文字、图片、视频、音频等各种形式的内容及其中包含的音乐、声音、台词、视觉设计、对话等所有组成部分，均由您原创或已获合法授权，不存在任何违反法律法规规定、侵犯他人合法权益（包括但不限于著作权、专利权、商标权等知识产权及人格权、个人信息权益等其他权益）、违反公序良俗的内容。在法律法规规定允许的范围内，您使用本AI产品的输入内容、生成内容及发布的信息内容的知识产权及产生的其他财产权益（如有）归属于您或依法享有该知识产权的权利人。</p>

          <h4>三、行为规范</h4>
          <p>您知悉并承诺，在使用本AI创作平台的过程中：您应尊重隐私和道德，并注意保护数据安全，不得输入、分享任何未经授权的个人信息、保密信息（包括但不限于商业秘密）及未经授权的其他类型的信息；您应尊重他人合法权益，确保您的输入内容均合法合规、为您本人所有或已获得合法授权，不得输入、分享任何未经授权的内容，不得侵害他人的著作权、专利权、商标权、肖像权、姓名权、声音权益、名誉权、荣誉权等权益。您不得使用本AI创作平台进行假冒他人实施侵权违法行为等非法活动，不得利用基于深度学习、虚拟现实、生成式人工智能等新技术新应用生成、制作、发布或传播谣言、不实信息等违法内容。</p>
          <p>您在生成、制作、发布或传播利用基于深度学习、虚拟现实、生成式人工智能等新技术新应用生成、合成的非真实信息或其他可能导致公众混淆或误认的信息内容时，我们有权根据《人工智能生成合成内容标识办法》《网络安全技术人工智能生成合成内容标识方法》等法律法规和强制性国家标准采取适当方式添加标识；同时，请您仔细阅读并理解相关法律法规和强制性国家标准中的标识管理要求，不得以任何方式遮挡、涂抹、修改或删除我们对AI内容添加的标识。请您理解并注意，如您未按照法律法规要求在AI内容上添加显式标识，导致公众混淆或误认的，因此所产生的后果和责任均由您自行承担。</p>

          <h4>四、功能使用责任声明</h4>
          <p>生成式及深度合成式人工智能可以为社会带来当前和潜在的好处，但是，由于技术限制或伦理问题，我们也十分关注AI技术能力被滥用的可能。我们在此提醒，您选择和使用本AI创作平台，应充分知悉并同意：</p>
          <p>(1)鉴于现阶段科学技术的局限性以及人工智能的性质，我们难以保证生成内容的真实性、准确性、可靠性、独特性。相同或相似输入内容在本AI创作平台的生成内容可能相同或相似。如输入内容包含参考图、参考音视频等内容，生成内容可能基于具体产品功能与您上传、发布的内容存在不同程度的相似性。请您结合自身需求并对生成内容进行客观、审慎地评估，避免对生成内容产生任何依赖或将其作为您采取或避免采取任何行动的依据。我们建议，在您根据生成内容采取任何行动之前，应当严肃考虑进一步咨询专业人士的建议，特别是与健康、医疗、财务、投资、保险、法律等涉及对您或者您的相关方可能会产生重大影响的事宜。</p>
          <p>（2）您应科学理性认识和依法使用生成式及深度合成式人工智能技术，不得违反本规范及与本AI创作平台有关的其他相关协议、社区自律公约、活动规则、公告、说明、站内信通知等（合称"平台规则"），了解并严格遵守《中华人民共和国数据安全法》《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《生成式人工智能服务管理暂行办法》《互联网信息服务深度合成管理规定》《人工智能生成合成内容标识办法》等法律法规的要求，承担因您自身违法行为可能导致的法律责任。</p>
          <p>（3）请您了解，我们非常重视模型的内容安全问题，将努力采取合理的安全措施来过滤模型产出的不正当有害内容，尽可能使得其生成内容符合预期，但可能仍有与预期不符的情况出现，请您知悉。</p>
          <p>2. 尽管我们已经尽了最大努力确保功能服务的连贯性和安全性，但由于现阶段科学技术的局限性，我们无法确保所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险。因此，除法律法规另有明确规定外，在任何情况下，我们均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任，该等损害包括但不限于您因使用本AI创作平台而遭受的利润损失、您因使用本AI创作平台功能服务或您依赖生成内容所采取的任何行为而遭受的损失。</p>

          <h4>五、未成年人保护</h4>
          <p>我们重视对未成年人个人信息及隐私的保护。我们特别提醒您在填写未成年人个人信息时应加强保护意识并谨慎使用和发布包含未成年人素材的内容。您应当取得使用和展示未成年人的肖像、声音等信息的全部合法授权及同意，且允许我们依据本规范使用、处理该等与未成年人相关的内容。如相关内容侵犯未成年人权利，我们在收到权利人通知或基于其他保障未成年人合法权益的考虑，有权处理相关内容并视情况通知您。</p>
        </div>
        <div class="agreement-footer">
          <el-button type="primary" @click="close">我已阅读并知晓</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AgreementDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.agreement-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.agreement-dialog {
  width: 680px;
  max-width: 90vw;
  height: 75vh;
  max-height: 800px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.agreement-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.agreement-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
}
.agreement-close {
  font-size: 18px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
}
.agreement-close:hover {
  color: #333;
}
.agreement-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 28px;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}
.agreement-body h4 {
  margin: 20px 0 10px;
  font-size: 15px;
  color: #222;
}
.agreement-body p {
  margin: 8px 0;
  text-align: justify;
}
.agreement-footer {
  display: flex;
  justify-content: center;
  padding: 14px 24px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.agreement-fade-enter-active,
.agreement-fade-leave-active {
  transition: opacity 0.25s ease;
}
.agreement-fade-enter,
.agreement-fade-leave-to {
  opacity: 0;
}
</style>
